import { GST_RATE_MILLI, QST_RATE_MILLI, type AppointmentView } from "@shared/modules/x-atelier";

// Affichage des taxes du Québec. Les MONTANTS viennent toujours de l'API
// (`taxes`, `totalWithTaxCents`, `dueCents`) : ici on ne fait que nommer les
// lignes et formater les taux — jamais de recalcul côté navigateur.

/** 5000 → « 5 % », 9975 → « 9,975 % ». */
export function formatRate(milli: number): string {
  const pct = milli / 1000;
  return `${pct.toLocaleString("fr-CA", { maximumFractionDigits: 3 })} %`;
}

export const GST_LABEL = `TPS (${formatRate(GST_RATE_MILLI)})`;
export const QST_LABEL = `TVQ (${formatRate(QST_RATE_MILLI)})`;

export interface AmountLine {
  key: "subtotal" | "gst" | "qst" | "imported-tax" | "total" | "paid";
  label: string;
  cents: number;
  /** Ligne mise en avant (total TTC). */
  strong?: boolean;
  /** Ligne grisée (taxe exonérée). */
  muted?: boolean;
}

/** Sous-total, TPS, TVQ, total et payé, prêts à afficher en tableau. */
export function amountLines(a: AppointmentView): AmountLine[] {
  const exempt = a.taxExempt;
  if (a.taxes.importedTotalCents !== undefined)
    return [
      { key: "subtotal", label: "Sous-total", cents: a.totalCents },
      { key: "imported-tax", label: "Taxes du devis Urable", cents: a.taxes.importedTotalCents },
      { key: "total", label: "Total", cents: a.totalWithTaxCents, strong: true },
      { key: "paid", label: "Payé", cents: a.paidCents },
    ];
  return [
    { key: "subtotal", label: "Sous-total", cents: a.totalCents },
    {
      key: "gst",
      label: exempt ? "TPS — exonéré" : GST_LABEL,
      cents: a.taxes.gstCents,
      muted: exempt,
    },
    {
      key: "qst",
      label: exempt ? "TVQ — exonéré" : QST_LABEL,
      cents: a.taxes.qstCents,
      muted: exempt,
    },
    { key: "total", label: "Total", cents: a.totalWithTaxCents, strong: true },
    { key: "paid", label: "Payé", cents: a.paidCents },
  ];
}
